import React, { useEffect, useState } from 'react';
import GeneralLogic from '../../functions/logic/general';
import { useSnackbar } from 'notistack';
import Spiner from '../../components/Spiner';

export default function ProductsForm(props) {
    const [code, setCode] = useState('');
    const [name, setName] = useState('');
    const [desc, setDesc] = useState('');
    const [price, setPrice] = useState('');
    const [discount, setDiscount] = useState('');
    const [departa, setDeparta] = useState(localStorage.getItem('departa') || '');
    const [cat, setCat] = useState(localStorage.getItem('cat') || '');
    const [tip, setTip] = useState(localStorage.getItem('tip') || '');
    const [mar, setMar] = useState(localStorage.getItem('mar') || '');
    const [mod, setMod] = useState(localStorage.getItem('mod') || '');
    const [mat, setMat] = useState(localStorage.getItem('mat') || '');
    const [estPro, setEstPro] = useState(localStorage.getItem('estPro') || '');

    const [status, setStatus] = useState('');
    const [gravaIva, setGravaIva] = useState('');
    const [spiner, setSpiner] = useState(false);

    // Detalles del producto
    const [weight, setWeight] = useState('');
    const [height, setHeight] = useState('');
    const [width, setWidth] = useState('');
    const [length, setLength] = useState('');
    const [size, setSize] = useState('');
    const [dimensions, setDimensions] = useState('');
    const [launchDate, setLaunchDate] = useState('');
    const [dueDate, setDueDate] = useState('');
    const [warranty, setWarranty] = useState('');
    const [rating, setRating] = useState('');
    const [minOrderQty, setMinOrderQty] = useState('');
    const [manufacturer, setManufacturer] = useState('');
    const [manufacturingYear, setManufacturingYear] = useState('');
    const [observation, setObservation] = useState('');
    const { enqueueSnackbar } = useSnackbar();
    const userToken = localStorage.getItem('userToken');
    const [departamentos, setDepartamentos] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [tipoProd, setTipoProp] = useState([]);
    const [marca, setMarca] = useState([]);
    const [modelo, setModelo] = useState([]);
    const [material, setMaterial] = useState([]);
    const [statuses, setStatuses] = useState([]);
    const [discount2, setDiscount2] = useState('');
    const [bodega, setBodega] = useState('');
    const [bodegaData, setBodegaData] = useState([]);

    useEffect(() => {
        getDepartamentos();
        getBodegas();
    
        const codeLS = localStorage.getItem("code");
        const nameLS = localStorage.getItem("name");
        const descLS = localStorage.getItem("description");
        const priceLS = localStorage.getItem("price");
        const discountLS = localStorage.getItem("discount");
        const statusLS = localStorage.getItem("status");
        const catLS = localStorage.getItem("cat");
        const tipLS = localStorage.getItem("tip");
        const marLS = localStorage.getItem("mar");
        const modLS = localStorage.getItem("mod");
        const matLS = localStorage.getItem("mat");
        const estProLS = localStorage.getItem("estPro");
    
        const weightLS = localStorage.getItem("weight");
        const heightLS = localStorage.getItem("height");
        const widthLS = localStorage.getItem("width");
        const lengthLS = localStorage.getItem("length");
        const sizeLS = localStorage.getItem("size");
        const dimensionsLS = localStorage.getItem("dimensions");
        const launchDateLS = localStorage.getItem("launchDate");
        const dueDateLS = localStorage.getItem("dueDate");
        const warrantyLS = localStorage.getItem("warranty");
        const ratingLS = localStorage.getItem("rating");
        const minOrderQtyLS = localStorage.getItem("minOrderQty");
        const manufacturerLS = localStorage.getItem("manufacturer");
        const manufacturingYearLS = localStorage.getItem("manufacturingYear");
        const observationLS = localStorage.getItem("observation");
    
        if (
            codeLS || nameLS || descLS || priceLS || discountLS || statusLS ||
            catLS || tipLS || marLS || modLS || matLS || estProLS ||
            weightLS || heightLS || widthLS || lengthLS || sizeLS || dimensionsLS ||
            launchDateLS || dueDateLS || warrantyLS || ratingLS ||
            minOrderQtyLS || manufacturerLS || manufacturingYearLS || observationLS
        ) {
            setCode(codeLS || '');
            setName(nameLS || '');
            setDesc(descLS || '');
            setPrice(priceLS || '');
            setDiscount(discountLS || '');
            setStatus(statusLS || '');
            setCat(catLS || '');
            setTip(tipLS || '');
            setMar(marLS || '');
            setMod(modLS || '');
            setMat(matLS || '');
            setEstPro(estProLS || '');
    
            setWeight(weightLS || '');
            setHeight(heightLS || '');
            setWidth(widthLS || '');
            setLength(lengthLS || '');
            setSize(sizeLS || '');
            setDimensions(dimensionsLS || '');
            setLaunchDate(launchDateLS || '');
            setDueDate(dueDateLS || '');
            setWarranty(warrantyLS || '');
            setRating(ratingLS || '');
            setMinOrderQty(minOrderQtyLS || '');
            setManufacturer(manufacturerLS || '');
            setManufacturingYear(manufacturingYearLS || '');
            setObservation(observationLS || '');
        } else if (props.formData) {
            const datForm = props.formData;
    
            setCode(datForm["sku"] || '');
            setName(datForm["nombre"] || '');
            setDesc(datForm["descripcion"] || '');
            setPrice(datForm["precio"] || '');
            setDiscount(datForm["stock"] || '');
            setStatus(datForm["nombre_parametro"] || '');
            setGravaIva(datForm["grava_iva"] || '');
            setDiscount2(datForm["tarifa_descuento"] || '');
    
            getSelect(
                datForm["nemonico_depar"],
                datForm["nemonico_cat"],
                datForm["nemonico_tipro"]
            );
    
            setDeparta(datForm["nemonico_depar"] || '');
            setCat(datForm["nemonico_cat"] || '');
            setTip(datForm["nemonico_tipro"] || '');
            setMar(datForm["nemonico_marca"] || '');
            setMod(datForm["nemonico_modelo"] || '');
            setMat(datForm["nemonico_materiales"] || '');
            setEstPro(datForm["nemonico_estados_prod"] || '');
            setBodega(datForm["id_bodega"] || '');
    
            setWeight(datForm["peso"] || '');
            setHeight(datForm["alto"] || '');
            setWidth(datForm["ancho"] || '');
            setLength(datForm["largo"] || '');
            setSize(datForm["talla"] || '');
            setDimensions(datForm["dimensiones"] || '');
            setLaunchDate(datForm["fecha_lanzamiento"] || '');
            setDueDate(datForm["fecha_vencimiento"] || '');
            setWarranty(datForm["garantia"] || '');
            setRating(datForm["calificacion"] || '');
            setMinOrderQty(datForm["cantidad_minima_pedido"] || '');
            setManufacturer(datForm["fabricante"] || '');
            setManufacturingYear(datForm["anio_fabricacion"] || '');
            setObservation(datForm["observacion"] || '');
        }
    }, [props]);
    

    const getBodegas = async () => {
        const response = await GeneralLogic.getBodegaLogic(userToken)
        if (!response.error) {
            setBodegaData(response.data)
        } else {
            enqueueSnackbar(response.message, {
                variant: response.variant,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            })
        }
    }

    const getSelect = async (depar, cat, tipoProd) => {
        const response = await GeneralLogic.getCategoriaPorDepartLogic(userToken, depar);
        const responseCat = await GeneralLogic.getTipoProdCategoriaLogic(userToken, cat);
        const responseTipo = await GeneralLogic.getMarcaTipoProdLogic(userToken, tipoProd);
        if (!response.error && !responseCat.error && !responseTipo.error) {
            setCategorias(response.data);
            setTipoProp(responseCat.data);
            setMarca(responseTipo.dataMarca);
            setModelo(responseTipo.dataModel);
            setMaterial(responseTipo.dataMateriales);
        } else {
            enqueueSnackbar(response.message, {
                variant: response.variant,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            });
        }

        return true;
    }

    const getDepartamentos = async () => {
        const response = await GeneralLogic.getDepartamentosLogic(userToken);
        const responseStatus = await GeneralLogic.statusProductsLogic(userToken);
        if (!response.error && !responseStatus.error) {
            setDepartamentos(response.data);
            setStatuses(responseStatus.data);
        } else {
            enqueueSnackbar(response.message, {
                variant: response.variant,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            });
        }
    }

    const handleChangeDepartamento = async (e) => {
        setSpiner(true);
        const selectedId = e.target.value;
        localStorage.setItem('departa', selectedId);
        setDeparta(localStorage.getItem('departa'));
        const response = await GeneralLogic.getCategoriaPorDepartLogic(userToken, selectedId);
        if (!response.error) {
            setCategorias(response.data);
        } else {
            enqueueSnackbar(response.message, {
                variant: response.variant,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            });
        }
        //}
        setSpiner(false);
    };

    const handleChangeCategorias = async (e) => {
        setSpiner(true);
        const selectedId = e.target.value;
        localStorage.setItem('cat', selectedId);
        setCat(localStorage.getItem('cat'));
        const response = await GeneralLogic.getTipoProdCategoriaLogic(userToken, selectedId);
        if (!response.error) {
            setTipoProp(response.data);
        } else {
            enqueueSnackbar(response.message, {
                variant: response.variant,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            });
        }
        //}
        setSpiner(false);
    };

    const handleChangeTipoProd = async (e) => {
        setSpiner(true);
        const selectedId = e.target.value;
        localStorage.setItem('tip', selectedId);
        setTip(localStorage.getItem('tip'));
        const response = await GeneralLogic.getMarcaTipoProdLogic(userToken, selectedId);

        if (!response.error) {
            setMarca(response.dataMarca);
            setModelo(response.dataModel);
            setMaterial(response.dataMateriales);
        } else {
            enqueueSnackbar(response.message, {
                variant: response.variant,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            });
        }
        //}
        setSpiner(false);
    };

    return (
        <>
            <Spiner opt={spiner} />
            <div className="card card-primary card-outline card-tabs">
                <div className="card-header p-0 pt-1 border-bottom-0">
                    <ul className="nav nav-tabs" id="custom-tabs-three-tab" role="tablist">
                        <li className="nav-item">
                            <a className="nav-link active" id="custom-tabs-three-home-tab" data-toggle="pill" href="#custom-tabs-three-cab" role="tab" aria-controls="custom-tabs-three-home" aria-selected="true">
                                <i className="fa fa-shopping-basket"></i> Información básica del producto
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" id="custom-tabs-three-profile-tab" data-toggle="pill" href="#custom-tabs-three-detail" role="tab" aria-controls="custom-tabs-three-profile" aria-selected="false">
                                <i className="fa fa-info-circle"></i> Información detallada del producto
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="card-body">
                    <div className="tab-content" id="custom-tabs-three-tabContent">
                        <div className="tab-pane fade show active" id="custom-tabs-three-cab" role="tabpanel" aria-labelledby="custom-tabs-three-home-tab">
                            <div className="row">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-3">
                                            <div className="form-group">
                                                <label>SKU código <span style={{ color: "red" }}>*</span></label>
                                                <input
                                                    type="text"
                                                    id="sku"
                                                    name="sku"
                                                    maxLength={10}
                                                    value={code} onChange={e => {
                                                        localStorage.setItem('code', e.target.value);
                                                        setCode(localStorage.getItem("code"));
                                                    }}
                                                    className="form-control"
                                                    placeholder="Ingresar SKU"
                                                    disabled={props.formData["sku"] ? "disabled" : ""}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-5">
                                            <div className="form-group">
                                                <label>Nombre <span style={{ color: "red" }}>*</span></label>
                                                <input
                                                    id="name"
                                                    name="name"
                                                    type="text"
                                                    maxLength={100}
                                                    value={name}
                                                    onChange={e => {
                                                        localStorage.setItem('name', e.target.value);
                                                        setName(localStorage.getItem("name"));
                                                    }}
                                                    className="form-control"
                                                    placeholder="Ingresar nombre"
                                                />
                                            </div>
                                        </div>
                                        
                                        <div className="col-sm-2">
                                            <div className="form-group">
                                                <label>Precio <span style={{ color: "red" }}>*</span></label>
                                                <input
                                                    id="price"
                                                    name="price"
                                                    type="text"
                                                    maxLength={5}
                                                    value={price}
                                                    onChange={e => {
                                                        localStorage.setItem('price', e.target.value.replace(/\D/g, ''));
                                                        setPrice(localStorage.getItem("price"));
                                                    }}
                                                    placeholder="Ingresar precio"
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div className="form-group">
                                                <label>Stock <span style={{ color: "red" }}>*</span></label>
                                                <input
                                                    id="stock"
                                                    name="stock"
                                                    maxLength={5}
                                                    type="text"
                                                    value={discount}
                                                    onChange={e => {
                                                        localStorage.setItem('discount', e.target.value.replace(/\D/g, ''));
                                                        setDiscount(localStorage.getItem("discount"));
                                                    }}
                                                    placeholder="Ingresar stock"
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>

                                        
                                        <div className="col-sm-12">
                                            <div className="form-group">
                                                <label>Descripción <span style={{ color: "red" }}>*</span></label>
                                                <input
                                                    id="desc"
                                                    name="desc"
                                                    type="text"
                                                    maxLength={1000}
                                                    value={desc}
                                                    onChange={e => {
                                                        localStorage.setItem('desc', e.target.value);
                                                        setDesc(localStorage.getItem("desc"));
                                                    }}
                                                    className="form-control"
                                                    placeholder="Ingresar descripción"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-2">
                                            <div className="form-group">
                                                <label>Fecha lanzamiento <span style={{ color: "red" }}>*</span></label>
                                                <input
                                                    id="launchDate"
                                                    name="launchDate"
                                                    type="date"
                                                    value={launchDate}
                                                    onChange={e => {
                                                        localStorage.setItem('launchDate', e.target.value);
                                                        setLaunchDate(localStorage.getItem("launchDate"));
                                                    }}
                                                    className="form-control"
                                                    placeholder="Ingresar fecha de lanzamiento"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div className="form-group">
                                                <label>Fecha vencimiento <span style={{ color: "red" }}>*</span></label>
                                                <input
                                                    id="dueDate"
                                                    name="dueDate"
                                                    type="date"
                                                    value={dueDate}
                                                    onChange={e => {
                                                        localStorage.setItem('dueDate', e.target.value);
                                                        setDueDate(localStorage.getItem("dueDate"));
                                                    }}
                                                    className="form-control"
                                                    placeholder="Ingresar fecha de vencimiento"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label className="form-label fw-bold">Seleccionar Departamento <span style={{ color: "red" }}>*</span></label>
                                                <select id="departa" value={departa}
                                                    name="departa" className="form-control" aria-label="Select 1" onChange={handleChangeDepartamento}>
                                                    <option value="">Selecciona un departamento </option>
                                                    {departamentos.map((departamentos) => (
                                                        <option key={departamentos.nemonico} value={departamentos.nemonico}>
                                                            {departamentos.nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label className="form-label fw-bold">Seleccionar categoría <span style={{ color: "red" }}>*</span></label>
                                                <select id="categoria" value={cat}
                                                    name="categoria" className="form-control" aria-label="Select 1" onChange={handleChangeCategorias}>
                                                    <option value="">Selecciona una categoría</option>
                                                    {categorias.map((categorias) => (
                                                        <option key={categorias.nemonico} value={categorias.nemonico}>
                                                            {categorias.nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label className="form-label fw-bold">Seleccionar tipo producto <span style={{ color: "red" }}>*</span></label>
                                                <select id="tipoProd" value={tip}
                                                    name="tipoProd" className="form-control" aria-label="Select 1" onChange={handleChangeTipoProd}>
                                                    <option value="">Selecciona tipo producto</option>
                                                    {tipoProd.map((tipoProd) => (
                                                        <option key={tipoProd.nemonico} value={tipoProd.nemonico}>
                                                            {tipoProd.nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label className="form-label fw-bold">Seleccionar marca <span style={{ color: "red" }}>*</span></label>
                                                <select id="marca"
                                                    value={mar}
                                                    onChange={e => {
                                                        localStorage.setItem('mar', e.target.value);
                                                        setMar(localStorage.getItem("mar"));
                                                    }}
                                                    name="marca" className="form-control" aria-label="Select 1">
                                                    <option value="">Selecciona marca</option>
                                                    {marca.map((marca) => (
                                                        <option key={marca.nemonico} value={marca.nemonico}>
                                                            {marca.nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label className="form-label fw-bold">Seleccionar Modelo</label>
                                                <select id="modelo"
                                                    value={mod}
                                                    onChange={e => {
                                                        localStorage.setItem('mod', e.target.value);
                                                        setMod(localStorage.getItem("mod"));
                                                    }}
                                                    name="modelo" className="form-control" aria-label="Select 1">
                                                    <option value="">Selecciona Modelo</option>
                                                    {modelo.map((modelo) => (
                                                        <option key={modelo.nemonico} value={modelo.nemonico}>
                                                            {modelo.nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label className="form-label fw-bold">Seleccionar Materiales</label>
                                                <select id="meteriales"
                                                    value={mat}
                                                    onChange={e => {
                                                        localStorage.setItem('mat', e.target.value);
                                                        setMat(localStorage.getItem("mat"));
                                                    }}
                                                    name="meteriales" className="form-control" aria-label="Select 1">
                                                    <option value="">Selecciona Materiales</option>
                                                    {material.map((material) => (
                                                        <option key={material.nemonico} value={material.nemonico}>
                                                            {material.nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label className="form-label fw-bold">Seleccionar Estado <span style={{ color: "red" }}>*</span></label>
                                                <select id="estados"
                                                    value={estPro}
                                                    onChange={e => {
                                                        localStorage.setItem('estPro', e.target.value);
                                                        setEstPro(localStorage.getItem("estPro"));
                                                    }}
                                                    name="estados" className="form-control" aria-label="Select 1">
                                                    <option value="">Selecciona Estado</option>
                                                    {statuses.map((statuses) => (
                                                        <option key={statuses.nemonico} value={statuses.nemonico}>
                                                            {statuses.nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label>Porcentaje descuento % <span style={{ color: "red" }}>*</span></label>
                                                <input
                                                    id="discountPorcent"
                                                    name="discountPorcent"
                                                    maxLength={5}
                                                    type="text"
                                                    value={discount2}
                                                    onChange={e => {
                                                        localStorage.setItem('discount2', e.target.value.replace(/\D/g, ''));
                                                        setDiscount2(localStorage.getItem("discount2"));
                                                    }}
                                                    placeholder="Ingresar porcentaje"
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>

                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label>Bodega <span style={{ color: "red" }}>*</span></label>
                                                <select id="bodega" value={bodega}
                                                    onChange={e => {
                                                        localStorage.setItem('bodega', e.target.value)
                                                        setBodega(localStorage.getItem("bodega"))
                                                    }}
                                                    name="bodega" className="form-control" aria-label="Select 1">
                                                    <option value="">Selecciona Bodega </option>
                                                    {bodegaData.map((bodegaItem) => (
                                                        <option key={bodegaItem.nemonico} value={bodegaItem.nemonico}>
                                                            {bodegaItem.nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div className="form-group">
                                                <label>Estado</label>
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        checked={status === "Activo"}
                                                        onChange={(e) => setStatus(e.target.checked ? "Activo" : "Inactivo")}
                                                        className="custom-control-input"
                                                        id="statusSwitch"
                                                    />
                                                    <label className="custom-control-label" htmlFor="statusSwitch">
                                                        {status === "Activo" ? "Activo" : "Inactivo"}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div className="form-group">
                                                <label>Grava iva</label>
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        checked={gravaIva === "Activo"}
                                                        onChange={(e) => setGravaIva(e.target.checked ? "Activo" : "Inactivo")}
                                                        className="custom-control-input"
                                                        id="ivaSwitch"
                                                    />
                                                    <label className="custom-control-label" htmlFor="ivaSwitch">
                                                        {gravaIva === "Activo" ? "Activo" : "Inactivo"}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tab-pane fade" id="custom-tabs-three-detail" role="detail" aria-labelledby="custom-tabs-three-profile-tab">
                            <div className="row">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label>Peso</label>
                                                <input
                                                    id="weight"
                                                    name="weight"
                                                    type="text"
                                                    value={weight}
                                                    onChange={e => {
                                                        localStorage.setItem('weight', e.target.value);
                                                        setWeight(localStorage.getItem("weight"));
                                                    }}
                                                    className="form-control"
                                                    placeholder="Ingresar peso"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label>Alto</label>
                                                <input
                                                    id="height"
                                                    name="height"
                                                    type="text"
                                                    value={height}
                                                    onChange={e => {
                                                        localStorage.setItem('height', e.target.value);
                                                        setHeight(localStorage.getItem("height"));
                                                    }}
                                                    className="form-control"
                                                    placeholder="Ingresar alto"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label>Ancho</label>
                                                <input
                                                    id="width"
                                                    name="width"
                                                    type="text"
                                                    value={width}
                                                    onChange={e => {
                                                        localStorage.setItem('width', e.target.value);
                                                        setWidth(localStorage.getItem("width"));
                                                    }}
                                                    className="form-control"
                                                    placeholder="Ingresar ancho"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label>Largo</label>
                                                <input
                                                    id="lengthd"
                                                    name="lengthd"
                                                    type="text"
                                                    value={length}
                                                    onChange={e => {
                                                        localStorage.setItem('length', e.target.value);
                                                        setLength(localStorage.getItem("length"));
                                                    }}
                                                    className="form-control"
                                                    placeholder="Ingresar largo"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label>Talla</label>
                                                <input
                                                    id="size"
                                                    name="size"
                                                    type="text"
                                                    value={size}
                                                    onChange={e => {
                                                        localStorage.setItem('size', e.target.value);
                                                        setSize(localStorage.getItem("size"));
                                                    }}
                                                    className="form-control"
                                                    placeholder="Ingresar talla"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label>Dimensiones Ej. (20x30x10)</label>
                                                <input
                                                    id="dimensions"
                                                    name="dimensions"
                                                    type="text"
                                                    value={dimensions}
                                                    onChange={e => {
                                                        localStorage.setItem('dimensions', e.target.value);
                                                        setDimensions(localStorage.getItem("dimensions"));
                                                    }}
                                                    className="form-control"
                                                    placeholder="Ingresar dimensiones"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label>Garantía</label>
                                                <input
                                                    id="warranty"
                                                    name="warranty"
                                                    type="text"
                                                    value={warranty}
                                                    onChange={e => {
                                                        localStorage.setItem('warranty', e.target.value);
                                                        setWarranty(localStorage.getItem("warranty"));
                                                    }}
                                                    className="form-control"
                                                    placeholder="Ingresar garantía"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label>Fabricante</label>
                                                <input
                                                    id="manufacturer"
                                                    name="manufacturer"
                                                    type="text"
                                                    value={manufacturer}
                                                    onChange={e => {
                                                        localStorage.setItem('manufacturer', e.target.value);
                                                        setManufacturer(localStorage.getItem("manufacturer"));
                                                    }}
                                                    className="form-control"
                                                    placeholder="Ingresar fabricante"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label>Año de fabricación</label>
                                                <input
                                                    id="manufacturingYear"
                                                    name="manufacturingYear"
                                                    type="text"
                                                    value={manufacturingYear}
                                                    onChange={e => {
                                                        localStorage.setItem('manufacturingYear', e.target.value.replace(/\D/g, ''));
                                                        setManufacturingYear(localStorage.getItem("manufacturingYear"));
                                                    }}
                                                    className="form-control"
                                                    placeholder="Ingresar año de fabricación"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-12">
                                            <div className="form-group">
                                                <label>Observación</label>
                                                <textarea
                                                    id="observation"
                                                    name="observation"
                                                    value={observation}
                                                    onChange={e => {
                                                        localStorage.setItem('observation', e.target.value);
                                                        setObservation(localStorage.getItem("observation"));
                                                    }}
                                                    className="form-control"
                                                    placeholder="Ingresar observación"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
